export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/tuner-icon.svg?38ebbe6eeb2d21b95c1e636954f2e1c9";